import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { DataTable } from '@components/ui/data.table/data-table';

import { useStockDetails } from '@/modules/stocks/stock-product-details/stock-product-details.hook';

const columns: Array<ColumnDef<any>> = [
    {
        accessorKey: 'id',
        header: () => <div className={'text-left'}>Batch ID</div>,
        cell: ({ row }) => <div>{row.original.serial}</div>,
    },

    {
        accessorKey: 'purchase_quantity',
        header: () => <div className={'text-right'}>Purchase Quantity</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.purchase_quantity}</div>
        ),
    },

    {
        accessorKey: 'current_stock',
        header: () => <div className={'text-right'}>Current Stock</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.current_stock}</div>
        ),
    },

    {
        accessorKey: 'expiration_date',
        header: () => <div className={'text-left'}>Expiration Date</div>,
        cell: ({ row }) => (
            <div>{format(row.original.expiration_date, 'dd MMM yyyy')}</div>
        ),
    },

    {
        accessorKey: 'purchase_price',
        header: () => <div className={'text-right'}>Purchase Price</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.purchase_price}</div>
        ),
    },

    {
        accessorKey: 'wholesale_price',
        header: () => <div className={'text-right'}>Wholesale Price</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.wholesale_price}</div>
        ),
    },
    {
        accessorKey: 'retail_price',
        header: () => <div className={'text-right'}>Retail Price</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.retail_price}</div>
        ),
    },
];

export const ProductStockBatchList = () => {
    const { data } = useStockDetails();
    return (
        <div>
            <DataTable
                columns={columns}
                data={
                    data?.data?.batches?.map((item: any, index: number) => ({
                        ...item,
                        serial: index + 1,
                    })) || []
                }
            />
        </div>
    );
};

ProductStockBatchList.displayName = 'ProductStockBatchList';
